module.exports = __webpack_public_path__ + "img/youtube-music.a08bca01.png";